import {Component, inject, OnInit, ViewEncapsulation} from '@angular/core';
import {SafePipe} from 'frontier/browserkit/src/lib/pipes/safe.pipe';
import {ApiConfigService} from 'frontier/nucleus/src/lib/apiv2/api-config.service';

@Component({
  selector: 'kpi4me-go-to-trapo',
  templateUrl: './go-to-trapo.component.html',
  styleUrls: ['./go-to-trapo.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [SafePipe],
})
export class GoToTrapoComponent implements OnInit {
  href: string;
  private _apiConfigService: ApiConfigService = inject(ApiConfigService);

  constructor() {
    if (this._apiConfigService.environment.env === 'prod') {
      this.href = window.location.origin + '/trapo'
    } else {
      this.href = this._apiConfigService.environment.url + '/trapo'
    }

    this.href = this.href + '/#/?hideToolbar=true';
  }

  ngOnInit(): void {
    return;
  }
}
